import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { getAuth, signOut } from "firebase/auth";
import { initializeFirebase } from "./initializeFirebase";
import HomeComponent from "./Components/HomeComponent/home";
import HazratBayanComponent from "./Components/HazratBayanComponent";
import BiographyComponent from "./Components/BiographyComponent/Biography";
import AskHazratComponent from "./Components/AskHazratComponent/AskHazrat";
import NaatComponent from "./Components/NaatComponent/Naat";
import Services from "./Components/Services2/Services";
import HazratBayan from "./Components/HazratBayan/HazratBayan";
import AddRecordingModal from "./Components/HazratBayanComponent/AddBayanComponent/AddBayanFriday";
import MuftiTaqi from "./Components/MuftiTaqiBayan/MuftiTaqi";
import AdminLogin from "./Components/LoginforAdmin/Login";
import UpdateJamaatTimings from "./Components/PrayerTimeComponent/UpdateJamatTimeAdmin";
import Footer1 from "./Components/FooterComponent/Footer1";
import Activities from "./Components/Activities/Activities";
import Blog from "./Components/Blog/Blog";
import Contact from "./Components/Contact/Contact";
import FridayBayanComponent from "./Components/FridayBayanComponent/FridayBayan";
import BayanPage from "./Components/FridayBayanComponent/BayanPage";
import SundayBayanComponent from "./Components/SundayBayanComponent/SundayBayan";
import ServicesDetailFuneral from "./Components/Services2/ServicesDetailFuneral";
import ServicesDetailQuranClasses from "./Components/Services2/ServicesDetailQuranClasses";
import ServicesDetailHelpingPoor from "./Components/Services2/ServicesDetailHelpingPoor";
import ServicesDetailMosqueDev from "./Components/Services2/ServicesDetailMosqueDev";
import AddBayanMorningDars from "./Components/HazratBayanComponent/AddBayanComponent/AddBayanMorningDars";
import UpdateandDeleteFridayBayan from "./Components/HazratBayanComponent/AddBayanComponent/UpdateandDeleteFridayBayan";
import UpdateandDeleteSundayBayan from "./Components/HazratBayanComponent/AddBayanComponent/UpdateandDeleteSundayBayan";
import EventDetail from "./Components/EventsComponent/EventDetail";
import HomePageEvents from "./Components/EventsComponent/HomePageEvents";
import CourseGirls from "./Components/EventsComponent/CourseGirls";
import NewEventModal from "./Components/EventsComponent/NewEventModal";
import EventGrid from "./Components/EventsComponent/AllEvents";
import AllEvents from "./Components/EventsComponent/AllEventsHome";

// HIFZ PORTAL IMPORTS
import DashboardAdmin from "./Components/HifzPortal/DashboardAdmin";
import DashboardQari from "./Components/HifzPortal/DashboardQari";
import Login from "./Components/HifzPortal/Login";
import ProtectedStudentDashboard from "./Components/HifzPortal/ProtectedStudentDashboard";
import StudentProgress from "./Components/HifzPortal/StudentProgress";
import QariStudentProfile from "./Components/HifzPortal/QariStudentProfile";
import LegacyQariStudentRedirect from "./Components/HifzPortal/LegacyQariStudentRedirect";
import ProtectedQariRoute from "./Components/HifzPortal/ProtectedQariRoute";
import { getEffectiveHifzUser } from "./Components/HifzPortal/hifzAuth";

function readHifzUserFromStorage() {
  const role = localStorage.getItem("role");
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");
  const email = localStorage.getItem("email") || "";
  return role && token ? { role, token, userId, email } : null;
}

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [value, setValue] = useState("1");

  // ✅ Store full user object instead of just role
  const [hifzUser, setHifzUser] = useState(readHifzUserFromStorage);

  useEffect(() => {
    if (!hifzUser) {
      const stored = readHifzUserFromStorage();
      if (stored) setHifzUser(stored);
    }
  }, [hifzUser]);

  const handleLogin = () => setIsLoggedIn(true);

  // ✅ Save full user info when logging in
  const handleHifzLogin = (user) => {
    localStorage.setItem("token", user.token);
    localStorage.setItem("role", user.role);
    localStorage.setItem("userId", user.userId);
    localStorage.setItem("email", user.email);
    setHifzUser(user);
  };

  const handleLogout = async () => {
    try {
      await signOut(getAuth());
    } catch (err) {
      console.error("Firebase sign-out failed:", err);
    }
    ["token", "role", "userId", "email"].forEach((key) =>
      localStorage.removeItem(key)
    );
    setHifzUser(null);
  };

  useEffect(() => {
    initializeFirebase();
  }, []);

  return (
    <BrowserRouter>
      <AppContent
        isLoggedIn={isLoggedIn}
        handleLogin={handleLogin}
        value={value}
        setValue={setValue}
        hifzUser={hifzUser}             // ✅ Pass user object
        handleHifzLogin={handleHifzLogin}
        handleLogout={handleLogout}
      />
    </BrowserRouter>
  );
}

function AppContent({ isLoggedIn, handleLogin, value, setValue, hifzUser, handleHifzLogin, handleLogout }) {
  const location = useLocation();
  const effectiveHifzUser = getEffectiveHifzUser(hifzUser);

  const hideFooterRoutes = ["/bayan"];
  const shouldHideFooter = hideFooterRoutes.some((route) =>
    location.pathname.startsWith(route)
  );

  return (
    <>
      <Routes>
        {/* General routes */}
        <Route path="/" element={<HomeComponent setValue={setValue} value={value} />} />
        <Route path="/update-jamat" element={isLoggedIn ? <UpdateJamaatTimings /> : <Navigate to="/login" />} />
        <Route path="/update-delete-morningfridaybayan" element={isLoggedIn ? <UpdateandDeleteFridayBayan /> : <Navigate to="/login" />} />
        <Route path="/update-delete-morningSundaybayan" element={isLoggedIn ? <UpdateandDeleteSundayBayan /> : <Navigate to="/login" />} />
        <Route path="/new-event-modal" element={isLoggedIn ? <NewEventModal /> : <Navigate to="/login" />} />
        <Route path="/all-events-flagged" element={isLoggedIn ? <EventGrid /> : <Navigate to="/login" />} />
        <Route path="/events/:id" element={<EventDetail />} />
        <Route path="/event-view/:id" element={<EventDetail />} />
        <Route path="/events" element={<AllEvents />} />
        <Route path="/login" element={<AdminLogin onLogin={handleLogin} />} />
        <Route path="/moulanaabdulsattar" element={<HazratBayan />} />
        <Route path="/muftitaqi" element={<MuftiTaqi />} />
        <Route path="/hazrat" element={<HazratBayanComponent setValue={setValue} value={value} />} />
        <Route path="/fridaybayan" element={<FridayBayanComponent />} />
        <Route path="/sundaybayan" element={<SundayBayanComponent />} />
        <Route path="/bayan/:id" element={<BayanPage />} />
        <Route path="/seerat" element={<BiographyComponent />} />
        <Route path="/about" element={<AskHazratComponent />} />
        <Route path="/naat" element={<NaatComponent />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services-detail-funeral" element={<ServicesDetailFuneral />} />
        <Route path="/services-detail-quranclasses" element={<ServicesDetailQuranClasses />} />
        <Route path="/services-detail-helpingpoor" element={<ServicesDetailHelpingPoor />} />
        <Route path="/services-detail-mosquedev" element={<ServicesDetailMosqueDev />} />
        <Route path="/courses" element={<Activities />} />
        <Route path="/newbayan" element={isLoggedIn ? <AddRecordingModal /> : <Navigate to="/login" />} />
        <Route path="/newbayanmorning" element={isLoggedIn ? <AddBayanMorningDars /> : <Navigate to="/login" />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/iftar-o-clock-2.0" element={<EventDetail />} />
        <Route path="/noor-after-ramadan" element={<CourseGirls />} />
        <Route path="/home-page-events" element={<HomePageEvents />} />

        {/* ✅ Hifz login and dashboards */}
        <Route path="/hifz-login" element={<Login onLogin={handleHifzLogin} />} />
        <Route
          path="/dashboard-admin"
          element={
            hifzUser?.role === "admin"
              ? <DashboardAdmin user={hifzUser} onLogout={handleLogout} />
              : <Navigate to="/hifz-login" />
          }
        />
        <Route
          path="/dashboard-qari"
          element={
            <ProtectedQariRoute hifzUser={hifzUser}>
              <DashboardQari user={effectiveHifzUser} onLogout={handleLogout} />
            </ProtectedQariRoute>
          }
        />
        {/* More specific paths first so /dashboard-student?token=... lands on main dashboard, not progress */}
        <Route
          path="/dashboard-student/progress"
          element={
            <ProtectedStudentDashboard hifzUser={hifzUser} onLogout={handleLogout} />
          }
        />
        <Route
          path="/dashboard-student/attendance"
          element={
            <ProtectedStudentDashboard hifzUser={hifzUser} onLogout={handleLogout} />
          }
        />
        <Route
          path="/dashboard-student/profile"
          element={
            <ProtectedStudentDashboard hifzUser={hifzUser} onLogout={handleLogout} />
          }
        />
        <Route
          path="/dashboard-student"
          element={
            <ProtectedStudentDashboard hifzUser={hifzUser} onLogout={handleLogout} />
          }
        />

        {/* Qari-only: student progress & profile (separate from student portal) */}
        <Route
          path="/dashboard-qari/students/:studentId/profile"
          element={
            <ProtectedQariRoute hifzUser={hifzUser}>
              <QariStudentProfile />
            </ProtectedQariRoute>
          }
        />
        <Route
          path="/dashboard-qari/students/:studentId"
          element={
            <ProtectedQariRoute hifzUser={hifzUser}>
              <StudentProgress user={effectiveHifzUser} />
            </ProtectedQariRoute>
          }
        />
        <Route
          path="/students/:studentId"
          element={
            <ProtectedQariRoute hifzUser={hifzUser}>
              <LegacyQariStudentRedirect />
            </ProtectedQariRoute>
          }
        />
        <Route
          path="/student-profile"
          element={<Navigate to="/dashboard-student/profile" replace />}
        />
      </Routes>

      {!shouldHideFooter && <Footer1 />}
    </>
  );
}

export default App;
